export const hints: { [key: string]: any[] } = {
  "en": [
    {
      "path": "Terrains Cards/Icones/stop.png",
      "hint": "Units moving in must stop and move no further on that turn."
    },
    {
      "path": "Terrains Cards/Icones/stop_b.png",
      "hint": "Units moving in may have to stop and move no further on that turn (see opposite)."
    },
    {
      "path": "Terrains Cards/Icones/stop_c.png",
      "hint": "Units moving in may have to stop and move no further on that turn (see opposite)."
    },
    {
      "path": "Terrains Cards/Icones/noatt.png",
      "hint": "Units moving in cannot attack that turn."
    },
    {
      "path": "Terrains Cards/Icones/noatt_b.png",
      "hint": "Units moving in may be unable to atack that turn (see opposite)."
    },
    {
      "path": "Terrains Cards/Icones/noatt_c.png",
      "hint": "Units moving in may be unable to attack that turn (see opposite)."
    },
    {
      "path": "Terrains Cards/Icones/los.png",
      "hint": "Block line of sight."
    },
    {
      "path": "Terrains Cards/Icones/los_b.png",
      "hint": "May block line of sight (see opposite)."
    },
    {
      "path": "Terrains Cards/Icones/los_c.png",
      "hint": "May block line of sight (see opposite)."
    },
    {
      "path": "Terrains Cards/Icones/flag.png",
      "hint": "Units on this terrain may ignore 1 flag."
    },
    {
      "path": "Terrains Cards/Icones/flag_b.png",
      "hint": "Units on this terrain may be able to ignore 1 flag (see opposite)."
    },
    {
      "path": "Terrains Cards/Icones/flag_c.png",
      "hint": "Units on this terrain may be able to ignore 1 flag (see opposite)."
    },
    {
      "path": "Terrains Cards/Def/inf-1.png",
      "hint": "Infantry units attacking an enemy unit on this terrain suffer a 1 die penalty."
    },
    {
      "path": "Terrains Cards/Def/inf-1_b.png",
      "hint": "Infantry units attacking an enemy unit on this terrain may suffer a 1 die penalty (see above)."
    },
    {
      "path": "Terrains Cards/Def/inf-2.png",
      "hint": "Infantry units attacking an enemy unit on this terrain suffer a 2 dice penalty."
    },
    {
      "path": "Terrains Cards/Def/inf-2_b.png",
      "hint": "Infantry units attacking an enemy unit on this terrain suffer a 2 dice penalty (see above)."
    },
    {
      "path": "Terrains Cards/Def/arm-1.png",
      "hint": "Armor units attacking an enemy unit on this terrain suffer a 1 die penalty."
    },
    {
      "path": "Terrains Cards/Def/arm-1_b.png",
      "hint": "Armor units attacking an enemy unit on this terrain may suffer a 1 die penalty (see above)."
    },
    {
      "path": "Terrains Cards/Def/arm-2.png",
      "hint": "Armor units attacking an enemy unit on this terrain suffer a 2 dice penalty."
    },
    {
      "path": "Terrains Cards/Def/arm-2_b.png",
      "hint": "Armor units attacking an enemy unit on this terrain suffer a 2 dice penalty (see above)."
    },
    {
      "path": "Terrains Cards/Def/art-1.png",
      "hint": "Artillery units attacking an enemy unit on this terrain suffer a 1 die penalty."
    },
    {
      "path": "Terrains Cards/Def/art-1_b.png",
      "hint": "Artillery units attacking an enemy unit on this terrain may suffer a 1 die penalty (see above)."
    },
    {
      "path": "Terrains Cards/Def/art-2.png",
      "hint": "Artillery units attacking an enemy unit on this terrain suffer a 2 dice penalty."
    },
    {
      "path": "Terrains Cards/Def/art-2_b.png",
      "hint": "Artillery units attacking an enemy unit on this terrain suffer a 2 dice penalty (see above)."
    }
  ],
  "fr": [
    {
      "path": "Terrains Cards/Icones/stop.png",
      "hint": "Entrer dans cet hex met fin au déplacement de l'unité pour ce tour."
    },
    {
      "path": "Terrains Cards/Icones/stop_b.png",
      "hint": "Entrer dans cet hex peut mettre fin au déplacement de l'unité pour ce tour (voir ci-contre)."
    },
    {
      "path": "Terrains Cards/Icones/stop_c.png",
      "hint": "Entrer dans cet hex peut mettre fin au déplacement de l'unité pour ce tour (voir ci-contre)."
    },
    {
      "path": "Terrains Cards/Icones/noatt.png",
      "hint": "Entrer dans cet hex empêche une unité d'attaquer lors du même tour."
    },
    {
      "path": "Terrains Cards/Icones/noatt_b.png",
      "hint": "Entrer dans cet hex peut empêcher une unité d'attaquer lors du même tour (voir ci-contre)."
    },
    {
      "path": "Terrains Cards/Icones/noatt_c.png",
      "hint": "Entrer dans cet hex peut empêcher une unité d'attaquer lors du même tour (voir ci-contre)."
    },
    {
      "path": "Terrains Cards/Icones/los.png",
      "hint": "Bloque la ligne de vue."
    },
    {
      "path": "Terrains Cards/Icones/los_b.png",
      "hint": "Peut bloquer la ligne de vue (voir ci-contre)."
    },
    {
      "path": "Terrains Cards/Icones/los_c.png",
      "hint": "Peut bloquer la ligne de vue (voir ci-contre)."
    },
    {
      "path": "Terrains Cards/Icones/flag.png",
      "hint": "Une unité sur ce terrain peut ignorer un drapeau."
    },
    {
      "path": "Terrains Cards/Icones/flag_b.png",
      "hint": "Une unité sur ce terrain est susceptible de pouvoir ignorer un drapeau (voir ci-contre)."
    },
    {
      "path": "Terrains Cards/Icones/flag_c.png",
      "hint": "Une unité sur ce terrain est susceptible de pouvoir ignorer un drapeau (voir ci-contre)."
    },
    {
      "path": "Terrains Cards/Def/inf-1.png",
      "hint": "L'infanterie subit un malus de 1 dé si elle attaque un ennemi situé sur ce terrain."
    },
    {
      "path": "Terrains Cards/Def/inf-1_b.png",
      "hint": "L'infanterie peut subir un malus de 1 dé si elle attaque un ennemi situé sur ce terrain (voir ci-dessus)."
    },
    {
      "path": "Terrains Cards/Def/inf-2.png",
      "hint": "L'infanterie subit un malus de 2 dés si elle attaque un ennemi situé sur ce terrain."
    },
    {
      "path": "Terrains Cards/Def/inf-2_b.png",
      "hint": "L'infanterie peut subir un malus de 2 dés si elle attaque un ennemi situé sur ce terrain (voir ci-dessus)."
    },
    {
      "path": "Terrains Cards/Def/arm-1.png",
      "hint": "Les blindés subissent un malus de 1 dé s'ils attaquent un ennemi situé sur ce terrain."
    },
    {
      "path": "Terrains Cards/Def/arm-1_b.png",
      "hint": "Les blindés peuvent subir un malus de 1 dé s'ils attaquent un ennemi situé sur ce terrain."
    },
    {
      "path": "Terrains Cards/Def/arm-2.png",
      "hint": "Les blindés subissent un malus de 2 dés s'ils attaquent un ennemi situé sur ce terrain."
    },
    {
      "path": "Terrains Cards/Def/arm-2_b.png",
      "hint": "Les blindés peuvent subir un malus de 2 dés s'ils attaquent un ennemi situé sur ce terrain."
    },
    {
      "path": "Terrains Cards/Def/art-1.png",
      "hint": "L'artillerie subit un malus de 1 dé si elle attaque un ennemi situé sur ce terrain."
    },
    {
      "path": "Terrains Cards/Def/art-1_b.png",
      "hint": "L'artillerie peut subir un malus de 1 dé si elle attaque un ennemi situé sur ce terrain (voir ci-dessus)."
    },
    {
      "path": "Terrains Cards/Def/art-2.png",
      "hint": "L'artillerie subit un malus de 2 dés si elle attaque un ennemi situé sur ce terrain."
    },
    {
      "path": "Terrains Cards/Def/art-2_b.png",
      "hint": "L'artillerie peut subir un malus de 2 dés si elle attaque un ennemi situé sur ce terrain (voir ci-dessus)."
    }
  ]
}